import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import FindingAndRecommendationHeader from "./FindingAndRecommendationHeader";
import FindingAndRecommendationDetails from "./FindingAndRecommendationDetails";
import {
  loadFindingAndRecommendationAsync,
  selectFindingAndRecommendation,
} from "../../../redux/slices/findingAndRecommendation";
import Page500 from "../../../pages/auth/Page500";

const Instruction = () => {
  const [loading, setLoading] = useState(false);
  const [
    loadingFindingAndRecommendationId,
    setLoadingFindingAndRecommendationId,
  ] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const findingAndRecommendationSelector = useAppSelector(
    selectFindingAndRecommendation
  );

  const dispatch = useAppDispatch();

  let { profileNo, findingAndRecommendationId } = useParams();
  if (!profileNo || !findingAndRecommendationId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingFindingAndRecommendationId !== findingAndRecommendationId) {
    setLoadingFindingAndRecommendationId(findingAndRecommendationId);
    dispatch(loadFindingAndRecommendationAsync(findingAndRecommendationId));
    return <Loading />;
  }

  const findingAndRecommendation =
    findingAndRecommendationSelector.findingAndRecommendation;

  if (!findingAndRecommendation) {
    return <Loading />;
  }

  if (!findingAndRecommendation.response.ok) {
    if (findingAndRecommendation.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FindingAndRecommendationHeader
            findingAndRecommendation={findingAndRecommendation}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FindingAndRecommendationDetails
            findingAndRecommendation={findingAndRecommendation}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            licenceProfile={licenceProfile}
            findingAndRecommendation={findingAndRecommendation}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        findingAndRecommendation={findingAndRecommendation}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default Instruction;
